<template>
  <div
    draggable="true"
    :id="id"
    class="border border-solid border-stroke rounded-4 px-2 pr-3 flex items-start cursor-pointer min-h-10 py-2 text-gray-800"
    :class="{ 'bg-primary bg-opacity-3': selectedEvaluateItemId === item.id, 'bg-white': selectedEvaluateItemId !== item.id, 'border-alert': invalid }"
    @dragstart.stop="onDragStart"
    @dragend.stop="onDragEnd"
    @click.stop="$emit('item-click', $event, item)"
  >
    <Icon v-if="icon" :name="icon" :class="[iconColor]" class="w-6 flex items-center justify-center flex-shrink-0 mr-2" />
    <component
      :is="component"
      :item="item"
      :selectedEvaluateItemId="selectedEvaluateItemId"
      :evaluate="evaluate"
      class="w-full overflow-hidden"
      :class="{ 'pointer-events-none': dragstart }"
      @item-click.stop="onItemClick"
      @update="onItemUpdate"
      @evaluate-update="$emit('evaluate-update', $event)"
    />
    <Checkbox v-if="selectable" :model-value="selected" @update:modelValue="$emit('select', item.id)" />
  </div>
</template>

<script>
import uuidv4 from '@/helpers/uuid';
import EvaluateItems, { Categories } from './EvaluateItems';
import { TRANSITION_ICONS } from '../../../helpers/flow';

export default {
  name: 'EvaluateItem',
  data() {
    return {
      id: uuidv4(),
      dragstart: false,
    };
  },
  props: {
    item: Object,
    evaluate: Array,
    selectedEvaluateItemId: String,
    selectable: Boolean,
    selected: Boolean,
    invalid: Boolean,
  },
  computed: {
    icon() {
      if (this.item.type === 'logic-transition') {
        return TRANSITION_ICONS[this.item.payload.type];
      }
      return EvaluateItems[this.item.type]?.icon || '';
    },
    iconColor() {
      return Categories.find((cat) => cat.key === EvaluateItems[this.item.type]?.category || '')?.color || '';
    },
    component() {
      return EvaluateItems[this.item.type]?.component || null;
    },
  },
  methods: {
    onItemUpdate($event) {
      this.$emit('update', JSON.parse(JSON.stringify({ ...this.item, payload: $event })));
    },
    /**
     * Starts dragging this block; the drop-zone type is only set when the block type has a registered component.
     * @param {DragEvent} e Native dragstart event.
     * @returns {void}
     */
    onDragStart(e) {
      e.dataTransfer.setData('id', this.item.id);
      e.dataTransfer.setData('item', JSON.stringify(this.item));
      if (this.component?.name) e.dataTransfer.setData('type', this.component.name);
      this.dragstart = true;
    },
    onDragEnd() {
      this.dragstart = false;
    },
    onItemClick($event, item) {
      this.$emit('item-click', $event, item);
    },
  },
};
</script>
